import { FC, useState } from 'react';
import { VideoPlayer } from 'src/components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import * as S from './styles';

interface VideoSectionProps {
  videoUrls: string[];
}

export const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <div />,
  prevArrow: <div />,
};

export const VideoSection: FC<VideoSectionProps> = ({ videoUrls }) => {
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);

  if (videoUrls.length === 0) return null;

  const handleBeforeChange = (_current: number, next: number) => {
    setActiveVideoIndex(next);
  };

  return (
    <S.VideoSection>
      {videoUrls.length === 1 ? (
        <S.VideoPlayerContainer>
          <VideoPlayer src={videoUrls[0]} playOnKeyboardShortcut={false} autoPlay={false} />
        </S.VideoPlayerContainer>
      ) : (
        <S.VideoSliderContainer>
          <Slider {...sliderSettings} beforeChange={handleBeforeChange}>
            {videoUrls.map((videoUrl, index) => (
              <div key={`video-${videoUrl}`}>
                <S.VideoPlayerContainer>
                  <VideoPlayer
                    src={videoUrl}
                    playOnKeyboardShortcut={false}
                    autoPlay={false}
                    // Only load the current video and adjacent ones
                    preload={Math.abs(index - activeVideoIndex) <= 1 ? 'metadata' : 'none'}
                  />
                </S.VideoPlayerContainer>
              </div>
            ))}
          </Slider>
        </S.VideoSliderContainer>
      )}
    </S.VideoSection>
  );
};

export default VideoSection;
